import { Modal, ModalBody, ModalHeader } from "reactstrap";

import Proptypes from "prop-types";
import classNames from "classnames";
import { useState, useEffect, memo } from "react";
import {
  modalBox,
  backDropClass,
  contentClassName,
  modalCloseBtn,
  isFullWidthClass,
  isFullWidthModalBody,
  isFullWidthContentClassName,
} from "@/assets/styles/common.module.scss";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";

const ModalBox = ({
  children,
  show,
  toggle,
  headerTxt,
  className,
  showHeader,
  size,
  isFullWidth,
  onModalDismiss,
  willScroll = false,
  ...other
}) => {
  const [loadSize, setLoadSize] = useState("md");

  useEffect(() => {
    if (window.innerWidth > 1400) setLoadSize("lg");
    else if (window.innerWidth < 770) setLoadSize("sm");
    else setLoadSize("md");
  }, []);

  const handleDismiss = () => {
    onModalDismiss();
    toggle();
  };

  const closeButton = (
    <div
      aria-hidden="true"
      className={classNames(modalCloseBtn, "my-auto")}
      onClick={handleDismiss}
    >
      <Image
        src={`${IMAGE_BASE_PATH}/images/close.svg`}
        alt="X"
        width={15}
        height={15}
      />
    </div>
  );

  return (
    <Modal
      isOpen={show}
      toggle={toggle}
      centered
      backdrop="static" // static, true
      keyboard={false}
      size={size || loadSize}
      className={classNames(modalBox, isFullWidth ? isFullWidthClass : "")}
      backdropClassName={classNames(backDropClass)}
      contentClassName={classNames(
        contentClassName,
        isFullWidth ? isFullWidthContentClassName : "",
        "rModalCard",
        className
      )}
      {...other}
    >
      {showHeader && (
        <ModalHeader toggle={toggle} close={closeButton}>
          <div className="me-4 color-primary" style={{ fontSize: "1rem" }}>
            {headerTxt}
          </div>
        </ModalHeader>
      )}
      <ModalBody
        style={{
          paddingBottom:
            !size && !showHeader && loadSize === "lg" ? "100px" : "24px",
          paddingTop:
            !size && !showHeader && loadSize === "lg" ? "100px" : "24px",
          overflowY: willScroll ? "scroll" : "auto",
          height: willScroll ? "75vh" : "auto",
        }}
        className={classNames(isFullWidthModalBody)}
      >
        {children}
      </ModalBody>
    </Modal>
  );
};

ModalBox.propTypes = {
  children: Proptypes.any,
  show: Proptypes.bool,
  toggle: Proptypes.func,
  headerTxt: Proptypes.string,
  className: Proptypes.string,
  showHeader: Proptypes.bool,
  size: Proptypes.string,
  isFullWidth: Proptypes.bool,
  onModalDismiss: Proptypes.func,
  willScroll: Proptypes.bool,
};

ModalBox.defaultProps = {
  showHeader: true,
  isFullWidth: false,
  onModalDismiss: () => {},
};

export default memo(ModalBox);
